import { DEFAULTS } from "./defaultSettings.js";
import { mentionConverter } from "./mention-converter.js";
import { tiptapExtensions } from "./tiptap/tiptap.js";
import { MENTION_TYPE } from "./types.js";
const pluginMentions = (config) => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    pmNodeConverters: [],
    pmMarkConverters: [mentionConverter],
    type: MENTION_TYPE,
    tiptapExtensions
  };
};
export {
  pluginMentions
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject.js";
injectCss();
